import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import React from 'react';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import theme from '../../config/theme';
import AdminSidebar from '../../layouts/admin/AdminSidebar';
import AdminHeader from '../../layouts/admin/AdminHeader';
import { Outlet } from 'react-router-dom';
import { useState } from "react";
import Loader from '../../helpers/loader/Loader';

function AdminDashboard() {
  const [isOpen, setIsOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  
  return (
    <React.Fragment>
      <ThemeProvider theme={theme} >
          <CssBaseline />
          <Loader loading={loading} />
          <Box sx={styles.container}>
              <AdminSidebar isOpen={isOpen} />
              <Box component="main" sx={styles.mainSection}>
                <Outlet context={[loading, setLoading]}/>
              </Box>
          </Box>
      </ThemeProvider>  
    </React.Fragment>
  );
}

/** @type {import("@mui/material").SxProps} */
const styles = {
  container:{
    display:'flex',
    bcolor:'neutral-light',
    height:'calc(100%-64px)'
  },
  mainSection:{
    p:4,
    width:'100%',
    height:'100%',
    overflow:'auto'
  }

}

export default AdminDashboard;
